/** @format */
import {MaterialSection} from './types';

export const SECTIONS: MaterialSection[] = [
  {
    id: 'setup',
    index: 1,
    title: 'Настройка проекта',
    description: [
      'Узнайте, как подключить доступы и настроить проект для эффективного использования.',
    ],
    videoId: 'https://kinescope.io/embed/rE4Ytiq8sy7vRDTfZyeNch',
  },
  {
    id: 'project',
    index: 2,
    title: 'Страница проекта',
    description: [
      'Узнайте, как использовать свои проекты легко и эффективно.',
      'В коротком видео мы объясняем смысл всех блоков на странице проекта и показываем, как пользоваться Адсенсором легко и эффективно.',
    ],
    videoId: 'https://kinescope.io/embed/ueAwEnf8ZZHTuYgqrAYvke',
  },
  {
    id: 'digital-cast',
    index: 3,
    title: 'Цифровой слепок',
    description: [
      'Узнайте, как использовать наш главный аналитический модуль в реальной работе.',
      'В коротком видео мы объясняем устройство рабочих пространств, демонстрируем богатые возможности графиков и показываем сценарии применения Цифрового слепка.',
    ],
    videoId: 'https://kinescope.io/embed/n68i9xHDPETX6dCFBcFCfe',
  },
];

export const HEADER_HEIGHT = 15;
export const HEADER_HEIGHT_MD = 22;
export const MARGIN_TOP = 12;
export const MARGIN_TOP_MD = 6;
export const MARGIN_BOTTOM = 6;

export const VIDEO_ASPECT_RATIO = 0.625; // 16:10
